import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import PhilosophySection from './components/PhilosophySection';
import VisionSection from './components/VisionSection';
import BusinessSection from './components/BusinessSection';
import ValuesSection from './components/ValuesSection';
import MissionSection from './components/MissionSection';
import CEOMessageSection from './components/CEOMessageSection';
import CompanySection from './components/CompanySection';
import ContactSection from './components/ContactSection';
import FooterSection from './components/FooterSection';

export default function Home() {
  return (
    <main>
      <Navbar />
      <HeroSection />
      <PhilosophySection />
      <VisionSection />
      <BusinessSection />
      <ValuesSection />
      <MissionSection />
      <CEOMessageSection />
      <CompanySection />
      <ContactSection />
      <FooterSection />
    </main>
  );
}
